

















































































































































































import { API_BILL_FILTER_OPTIONS } from "@/configs/Apis";
import { Component, Prop, Vue } from "vue-property-decorator";
import { showError, showSuccess, showWarning } from "@/utils/Common";
import {
  MSG_ADD_SUCCESS,
  MSG_INVALID_PAGE,
  MSG_MODIFY_SUCCESS,
} from "@/configs/Consts";
import { Fetcher as Ajax } from "@/utils/Request";
@Component
export default class BillForm extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  billItem!: any;

  filterOptions = {
    revenueCategoryList: [],
    expenseCategoryList: [],
    buildingList: [],
    employeeList: [],
  };

  mounted() {
    Ajax.queryData(API_BILL_FILTER_OPTIONS, {}, "GET")
      .then((rs: any) => {
        this.filterOptions = rs || {
          revenueCategoryList: [],
          expenseCategoryList: [],
          buildingList: [],
          employeeList: [],
        };
      })
      .catch(() => {
        this.filterOptions = {
          revenueCategoryList: [],
          expenseCategoryList: [],
          buildingList: [],
          employeeList: [],
        };
      });
  }

  isEditBill() {
    return this.billItem && this.billItem.id;
  }

  saveBill() {
    const form = this.$refs.billForm as any;
    form.validate((isValid: boolean) => {
      if (!isValid) {
        showWarning(MSG_INVALID_PAGE);
        return;
      }
      const billData = JSON.parse(JSON.stringify(this.billItem));
      billData.revenueCategoryId = billData.revenueCategoryId > 0 ? billData.revenueCategoryId : 0;
      billData.expenseCategoryId = billData.expenseCategoryId > 0 ? billData.expenseCategoryId : 0;
      billData.buildingId = billData.buildingId > 0 ? billData.buildingId : 0;
      billData.employeeId = billData.employeeId > 0 ? billData.employeeId : 0;
      this.$store
        .dispatch(
          this.isEditBill() ? "bill/updateBill" : "bill/addBill",
          billData
        )
        .then(() => {
          this.$emit("update:billItem", {});
          showSuccess(this.isEditBill() ? MSG_MODIFY_SUCCESS : MSG_ADD_SUCCESS);
          this.$emit("data-success");
        })
        .catch(({ message }) => showError(message));
    });
  }
}
